<!-- 
  🛠定制开发 - 专业团队提供个性化开发服务
  💳支付通道对接 - 快速对接第三方支付平台
  🤝业务合作 - 多种合作模式，共创双赢
  QQ: 3909001743 | Telegram: @sy9088 
-->
<template>
  <div id="app">   
    <router-view/>
  </div>
</template>
<script>

  export default {
    name: 'App',
      mounted() {
       
      }
  }
</script>
<style lang="scss">
  html,body{
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, 微软雅黑, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    color: #333;
    background-color: #f5f7fa;
  }
</style >